var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeAnnouncement)?_c('v-dialog',{attrs:{"content-class":"popup-announcement-dialog","max-width":"620","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c(_vm.activeComponent,{tag:"component",on:{"dismiss":_vm.dismiss}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }